import { lazy } from "react";

const edit = lazy(() => import("./Edit").then(m => ({ default: m.ServiceProviderNotesEdit })));
const list = lazy(() => import("./List").then(m => ({ default: m.ServiceProviderNotesList })));
const create = lazy(() => import("./Create").then(m => ({ default: m.ServiceProviderNotesCreate })));

export default { edit, list, create };
